import { createContext, useCallback, useContext, useRef, useState } from 'react'
import { Text } from '@cinesend/ui-kit'
import AppDialog from '../components/app_dialog'

const ConfirmContext = createContext(null)

export function ConfirmDialogProvider({ children }) {
  const [request, setRequest] = useState(null)
  const requestRef = useRef(null)

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      const next = { ...options, resolve }
      requestRef.current = next
      setRequest(next)
    })
  }, [])

  const settle = (accepted) => {
    const current = requestRef.current
    requestRef.current = null
    setRequest(null)
    current?.resolve(accepted)
  }

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {request && (
        <AppDialog
          title={request.title}
          onClose={() => settle(false)}
          confirmText={request.confirmText}
          confirmVariant={request.confirmVariant}
          onConfirm={() => settle(true)}
        >
          <Text as='p' variant='sm' tone='secondary'>
            {request.name ? (
              <>
                Are you sure you want to delete this{' '}
                <Text as='span' variant='sm-medium' tone='primary'>
                  {request.name}
                </Text>{' '}
                {request.noun}?{request.detail ? ` ${request.detail}` : ''}
              </>
            ) : (
              request.message
            )}
          </Text>
        </AppDialog>
      )}
    </ConfirmContext.Provider>
  )
}

export function useConfirm() {
  return useContext(ConfirmContext)
}
